import { Database } from 'lucide-react'
import { AE_SYSTEM_COPY } from '#app/routes/mocra+/_form+/components/ae-systems/constants.ts'
import {
	aeSystemCardTitle,
	formatAeSystemSummary,
	type AeSystemDraft,
} from '#app/routes/mocra+/_form+/components/ae-systems/types.ts'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

type Props = {
	readonly system: AeSystemDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function AeSystemCard({
	system,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = aeSystemCardTitle(system)
	const description = formatAeSystemSummary(system)
	const hasErrors = Boolean(errors && errors.length > 0)

	return (
		<EntityCard
			title={title}
			description={hasErrors ? `${description} • Needs attention` : description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={AE_SYSTEM_COPY.remove.title}
			removeConfirmDescription={AE_SYSTEM_COPY.remove.description}
			icon={
				<Database
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
		/>
	)
}
